//import auth from '@/plugins/auth'
import router, { constantRoutes, dynamicRoutes } from '@/router'
import { getRouters } from '@/api/menu'
import Layout from '@/layout/index'

const permission = {
  namespaced: true,
  state: {
    routes: [],
    addRoutes: [],
    defaultRoutes: [],
    topbarRouters: [],
    // 侧边栏权限
    sidebarRouters: [],
    // 按钮权限
    buttonPermissions: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    SET_DEFAULT_ROUTES: (state, routes) => {
      state.defaultRoutes = constantRoutes.concat(routes)
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    },
    SET_BUTTON_PERMISSION: (state, routes) => {
      state.buttonPermissions = routes;
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit }) {
      return new Promise(resolve => {
        // 向后端请求路由数据
        getRouters().then(res => {
          if (!res.ok) {
            console.log("请求报错:" + res.msg);
            return;
          }
          const sidebarRoutes = filterPermissionRoutes(res.data, constantRoutes);
          commit('SET_SIDEBAR_ROUTERS', sidebarRoutes);
          commit('SET_BUTTON_PERMISSION', filterButtonPermission(res.data));
          resolve(sidebarRoutes)
        })
      })
    }
  }
}

/**
 * 过滤权限路由
 * @param permissionRoutes 后端返回的权限路由
 * @param supportRoutes 前端支持的路由
 * @returns {*[]}
 */
function filterPermissionRoutes(permissionRoutes, supportRoutes) {
  const copyRoutes = Object.assign([], permissionRoutes);
  const res = []
  for (let i = 0; i < copyRoutes.length; i++) {
    let route = Object.assign({}, copyRoutes[i]);
    if (route.type === 'C') {
      route.path = route.permission;
      if (!route.path.startsWith('/')) {
        route.path = '/' + route.path;
      }
      let r = getSupportRoute(route, supportRoutes);
      if (r) {
        res.push(r);
      }
      // if (route.children) {
      //   let children = Object.assign([], route.children);
      //   res.push(filterPermissionRoutes(children, supportRoutes));
      // }
    }
  }
  return res
}

/**
 * 过滤出按钮权限
 * @param asyncRouterMap
 * @returns {*[]}
 */
function filterButtonPermission(asyncRouterMap) {
  const copyRoutes = Object.assign([], asyncRouterMap);
  let bPers = [];
  for (let i = 0; i <copyRoutes.length; i++) {
    let route = Object.assign({}, copyRoutes[i]);
    if (route.type == 'F') {
      bPers.push(route.permission);
    }
    if (route.children) {
      let children = Object.assign([], route.children);
      bPers.concat(filterButtonPermission(children));
    }
  }
  return bPers;
}

function getSupportRoute(permissionRoute, supportRoutes) {
  for (let i = 0; i < supportRoutes.length; i++) {
    let supportRoute = supportRoutes[i];
    if (permissionRoute.path === supportRoute.path) {
      return supportRoute;
    }
  }
  return null;
}

export const loadView = (view) => {
  if (process.env.NODE_ENV === 'development') {
    return (resolve) => require([`@/views/${view}`], resolve)
  } else {
    // 使用 import 实现生产环境的路由懒加载
    return () => import(`@/views/${view}`)
  }
}

export default permission
